module.exports = __webpack_public_path__ + "static/media/dashboardNormal.fce7ff80.svg";